import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export interface CancelReasonCode {
  code: string;
  label: string;
  display: string;
}

export interface CancelReasonCodesResponse {
  cancelReasonCodes: CancelReasonCode[];
}

export const useCancelReasonCodes = () => {
  return useApi<CancelReasonCodesResponse>({
    queryOptions: {
      queryFn: async () => {
        const response = await axiosInstance.get<CancelReasonCodesResponse>(
          "/new-api/encounter/cancel-reason-codes",
        );
        return response.data;
      },
      queryKey: QueryKeys.Patient.Chart.CANCEL_REASON_CODES,
      staleTime: Number.POSITIVE_INFINITY,
    },
  });
};
